var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"outlined":"","dense":"","label":"Period","hide-details":"auto","type":"number","value":_vm.selectedNode.settings.period},on:{"input":(val) => _vm.onUpdate(val, 'settings.period')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }